import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { Categories, CreateCategory, UpdateCategory } from "./pages";
import { Category } from "./pages/category";

export const CategoriesRouter = [
  <Route
    path="/categories"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Categories />
      </ProtectedRoute>
    }
  />,

  <Route path="/category">
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Category />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateCategory />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateCategory />
        </ProtectedRoute>
      }
    />
  </Route>,
];
